module.exports = __webpack_public_path__ + "img/flyer_01.078ca386.jpeg";